import { render, staticRenderFns } from "./LicensingFees.vue?vue&type=template&id=27cf1d7a&scoped=true&"
import script from "./LicensingFees.vue?vue&type=script&lang=js&"
export * from "./LicensingFees.vue?vue&type=script&lang=js&"
import style0 from "./LicensingFees.vue?vue&type=style&index=0&id=27cf1d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf1d7a",
  null
  
)

export default component.exports